import { type HttpGet, buildQueryString } from '@/shared/infra/http'
import type { ListEquipmentItemOptions } from '@/shared/domain/use-cases'

type EquipmentItemOptionDto = { id: string; name: string }
type ListEquipmentResponse = { items: EquipmentItemOptionDto[] }

export class EdgeListEquipmentItemOptionsRepository {
  constructor(private readonly http: HttpGet) {}

  execute: ListEquipmentItemOptions = async ({ orgId, orgType }) => {
    const response = await this.http.get<ListEquipmentResponse>({
      url: `/equipment${buildQueryString({ orgId, orgType, limit: 100, offset: 0 })}`,
    })
    return response.items.map((item) => ({ id: item.id, name: item.name }))
  }
}
